import { useState } from 'react';
import { updateAddress } from "auth/store/action";
import { useDispatch } from 'react-redux';
import { API_STATUS } from 'core-lib/constants/network';
import { UserAddress } from '../components/AddAddressV3/types/types';
import { fetchUserAddress } from '../components/AddAddressV3/services/fetchUserAddress';

export function useAddress() {
  const [apiStatus, setApiStatus] = useState(API_STATUS.default);
  const [addressList, setAddressList] = useState<UserAddress[]>([]);
  const dispatch = useDispatch();

  const fetchAddress = async () => {
    dispatch(
      updateAddress({
        userAddresses: {
          apiStatus: API_STATUS.in_progress,
          addressList: [],
        },
      })
    );

    setApiStatus(API_STATUS.in_progress);

    let userAddresses = {
      apiStatus: API_STATUS.failure,
      addressList: [],
    };

    const { response, error }: any = await fetchUserAddress();

    if (response) {
      const result = response.sort((a, b) => b.id - a.id);
      setAddressList(result);

      userAddresses = {
        apiStatus: API_STATUS.success,
        addressList: result,
      };
      setApiStatus(API_STATUS.success);
    } else if (error) {
      setApiStatus(API_STATUS.failure);
    }

    dispatch(
      updateAddress({
        userAddresses,
      })
    );
  };

  return {
    fetchUserAddresses: fetchAddress,
    addressList,
    apiStatus,
  };
}
